
import {React, Component} from 'react'

import Web3 from 'web3'
import pxgABI from '../../assets/pxg-abi.json'

import Header from '../../components/Header/Header'
import FormInput from '../../components/FormInput/FormInput'
import pxgGif from '../../assets/pxg.gif'
import './Classify.css';


class Classify extends Component {
  constructor(props){
    super(props)
    this.state = {
      userUnclassifiedGlyphIds: [],
      grouped_labels: [ 
        {
          color: "cornflowerblue",
          labels: ["shape", "heart", "circle", "square", "triangle"]

        },        
        {
          color: "plum",
          labels: ["animal", "ape", "bear", "bird", "bug", "bunny", "bull", "cat",  "crab", "dog", "flower", "fox", "frog", "jellyfish", "mammal", "mouse", "plant", "panda", "reptile"]

        },
        {
          color: "lightgrey",
          labels:['creature', "cyclops", "alien", "android", "blob", "ghost", "human", "ogre", "robot", "slime", "skeleton", "transformer",  "zombie" ]
        },
  
        {
          color: "burlywood",
          labels: ["abstract", "dark",  "holes", "minimal",  "light", "lowContrast", "highContrast", "xSymmetrical", "twoTone", "upsidedown"]

        },
        {
          color: "mediumpurple",
          labels: ["face", "eyes", "ears", "horns", "mouth", "nose"]

        },
        {
          color: "darkseagreen",
          labels: ["object", "comet", "food", "hat",  "helmet", "mask", "skull", "spaceship", "invader", "tool"]

        },
        {
          color: "lightcoral",
          labels: ["emoji", "smiley", "idk"]

        },
      ],

      selected_labels: {upsidedown: false, horns: false, hat: false, food: false, transformer: false, comet: false, spaceship:false, triangle:false, bird: false, smiley:false, zombie: false, cyclops: false, ogre: false, face: false, eyes: false, mouth: false, ears: false, nose: false, bug: false, blob: false, slime: false, fox: false, plant: false, flower: false, bunny: false, android: false, jellyfish: false, mammal: false, reptile: false, skeleton: false,shape: false, heart: false, circle: false, square: false, animal: false, alien: false, ape: false, bear: false, bull: false, cat: false, creature: false,  crab: false, dog: false, frog: false, ghost: false, human: false, mouse: false, panda: false, robot: false, abstract: false, dark: false,  holes: false, minimal: false,  light: false, lowContrast: false, highContrast: false, xSymmetrical: false, twoTone: false, object: false,  helmet: false, mask: false, skull: false,  invader: false, tool: false,emoji: false, idk: false},
      other: "",
      currentGlyphId: null,
      currentGlyphImgUrl: pxgGif,
      currentGlyphName: "Pixelglyph",
      userAddress: "0x0000000000000000000000000"
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.formInputHandler = this.formInputHandler.bind(this)
    this.newGlyph = this.newGlyph.bind(this)
  }

  formInputHandler(label){ //handle form input. the buttons are done with some hackey state variable. Should use useRef() in the future
        var newSelectedLabels = this.state.selected_labels
        newSelectedLabels[label] = !this.state.selected_labels[label]
        this.setState({selected_labels: newSelectedLabels}) //use destructuring here lol
  }

  async handleSubmit(){

    //add any user owned glyphs to classified array after classification
    let classifiedList =  JSON.parse(localStorage.getItem("classified")) || []
    
    if(this.state.userUnclassifiedGlyphIds.includes(`${this.state.currentGlyphId}`)){
    
        classifiedList.push(`${this.state.currentGlyphId}`) //passing in a string because i use this later for comparison(includes function not == operator) against a string value. this is a restriction of the database schema
        localStorage.setItem("classified", JSON.stringify(classifiedList))
    }

  

    localStorage.setItem("testA", JSON.stringify(["10","20","30","17"]))
    //set up http post request body
    var classification = []
    for (var key in this.state.selected_labels){
        if(this.state.selected_labels[key]){
            classification.push(key)
        }
    }
    
    var postData = {
        "classification": classification,
        "other": this.state.other,
        "id": this.state.currentGlyphId,
        "wallet": this.state.userAddress
    }

    //submit user classifications to backendapi. backend api handles etl/crud 
    const resp = fetch("https://jittery-river-production.up.railway.app/submit", {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'no-cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'omit', // include, *same-origin, omit
        headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(postData) // body data type must match "Content-Type" header
    })
    
    let newUserUnclassifiedGlyphIds = this.state.userUnclassifiedGlyphIds
    newUserUnclassifiedGlyphIds.splice(this.state.userUnclassifiedGlyphIds.findIndex(element=> parseInt(element) == this.state.currentGlyphId),1)
    //remove the just classified user glyph from the list of unclassified user glyphs (all done via id) TODO: don't update state
    this.setState({ userUnclassifiedGlyphIds : newUserUnclassifiedGlyphIds,})
    //reset state (fetch a new glyph and change currentGlyphId) to render new glyph
    this.newGlyph()

    //scroll the document back up to the top to help mobile users keep on classifying after pressing submit buton
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

  }

  //reset state to render new glyph by updating state with a new glyph
  newGlyph(){

    


    // console.log("next unclassified glyph to fetch:", this.state.userUnclassifiedGlyphIds[this.state.userUnclassifiedGlyphIds.length-1])
    // console.log("request url conditional value:", this.state.userUnclassifiedGlyphIds.lenght)
    //grab a user's unclassified glyph else grab a random glyph
    let requestUrl =  this.state.userUnclassifiedGlyphIds[this.state.userUnclassifiedGlyphIds.length-1] ? `https://jittery-river-production.up.railway.app/glyph/${this.state.userUnclassifiedGlyphIds[this.state.userUnclassifiedGlyphIds.length-1]}` : "https://jittery-river-production.up.railway.app/glyph/random";
    // console.log("grabbing new glyph via url:", requestUrl)
    
    fetch(requestUrl, {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      headers: {
          'Access-Control-Allow-Origin': '*'
          },
  }).then(response=>response.json()).then(data=>{
      this.setState({ 
          selected_labels: {upsidedown: false, horns: false, hat: false, food: false, transformer: false, comet: false, spaceship:false, triangle:false, bird: false, smiley:false, zombie: false, cyclops: false, ogre: false, face: false, eyes: false, mouth: false, ears: false, nose: false, bug: false, blob: false, slime: false, fox: false, plant: false, flower: false, bunny: false, android: false, jellyfish: false, mammal: false, reptile: false, skeleton: false,shape: false, heart: false, circle: false, square: false, animal: false, alien: false, ape: false, bear: false, bull: false, cat: false, creature: false,  crab: false, dog: false, frog: false, ghost: false, human: false, mouse: false, panda: false, robot: false, abstract: false, dark: false,  holes: false, minimal: false,  light: false, lowContrast: false, highContrast: false, xSymmetrical: false, twoTone: false, object: false,  helmet: false, mask: false, skull: false,  invader: false, tool: false,emoji: false, idk: false},
          other: "",
          currentGlyphId: data["id"],
          currentGlyphImgUrl: data["image"],
          currentGlyphName: data["name"]  
      })
  })
  }

  async grabUserUnclassifiedGlyphs(){
    const pxgAddress = "0xF38d6BF300d52bA7880b43cDDB3F94ee3C6C4Ea6"

    if (typeof window.ethereum !== 'undefined') {
      // console.log('MetaMask is installed!');
      window.ethereum.request({ method: 'eth_requestAccounts' }).then(data=>{
          const accounts = data
          let walletAddress = accounts[0];
          // console.log("walletAddress", walletAddress)


          window.web3 = new Web3(window.ethereum)

          let pxgContract = new window.web3.eth.Contract(pxgABI,pxgAddress)
          // console.log("pxg contract", pxgContract)
    
          pxgContract.methods.balanceOf(walletAddress).call({from:walletAddress}).then(async (data)=>{
              let numGlyphs = data
              // console.log("num glyphs", numGlyphs)
              let glyphIds = []
              for(let i = 0; i < numGlyphs; i++){
                let currGlyphId = await pxgContract.methods.tokenOfOwnerByIndex(walletAddress, i).call({from:walletAddress})
                glyphIds.push(currGlyphId)
              }
        
              // console.log("glyphIds:", glyphIds)

              let glyphIdsSet = new Set()
              let alreadyClassified = await JSON.parse(localStorage.getItem("classified")) || []
        
              //add all user's glyphs to set
              glyphIds.forEach(id=>glyphIdsSet.add(id))
              //remove glyphs from user's glyph set if already classified
              alreadyClassified.forEach(elem=>glyphIdsSet.delete(elem))
              //add unclassified glyphs to array
              let unclassifiedGlyphs = []
              for (const item of glyphIdsSet) {
                unclassifiedGlyphs.push(item)
              }
              
        
              this.setState({
                userUnclassifiedGlyphIds : unclassifiedGlyphs,
                userAddress : walletAddress
              })


        }).catch(error=>console.log(error))
      }).catch(error=>console.log(error));
     


      // return unclassifiedGlyphs
    }
  }

  async componentDidMount(){
    
    let unclassifiedGlyphs = await this.grabUserUnclassifiedGlyphs()
    //fetch a random glyph or fetch a users glyphs
    fetch("https://jittery-river-production.up.railway.app/glyph/random", {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        headers: {
            'Access-Control-Allow-Origin': '*'
            },
    }).then(response=>response.json()).then(data=>{
        this.setState({ 
            // userUnclassifiedGlyphIds: unclassifiedGlyphs,
            currentGlyphId: data["id"],
            currentGlyphImgUrl: data["image"],
            currentGlyphName: data["name"]
        })
    })
    
  }
  

  render(){

    return (
        <div className="Classify">
            <Header/>
            <div style={{fontSize:"65px", margin:"20px 0px 0px 0px", fontWeight:"900", letterSpacing:"3px"}}>What Do You See?</div>
            <div className="cols" style={{margin:"20px", display: "flex", flexWrap:"wrap", flex:"1"}}>
              <div style={{margin:"20px", marginBottom:"0px", width:"45%",  minWidth:"400px"}}>
                    <img src={this.state.currentGlyphImgUrl} style={{ width:"80%", borderRadius:"5px"}}/>
              </div>
              <div style={{fontSize:"2vw", margin:"20px", marginBottom:"0px", width:"45%", minWidth:"350px"}}>
              {this.state.grouped_labels.map(elem=>{
                    var label_color = elem.color
                    return(
                    <span>
                    {elem.labels.map(elem=><FormInput formHandler={this.formInputHandler} color={label_color} data={elem} selected={this.state.selected_labels[elem]} style={{fontSize:"22px", padding: "5px 10px" }}/>)}
                    </span>
                    )
                    })
                }
                    
                    {/* <input className="other" type="text" placeholder="Other?"  onChange={(e)=>{this.setState({other:e.target.value})}}/> */}
                    <div style={{fontSize:"13px"}}>
                      * if you want to skip one, submit with nothing selected
                    </div>
                    <div>
                      <button className="submit" onClick={()=>{this.handleSubmit()}}>submit</button>
                    </div>

                   
                    
              </div>
            
           </div>


          

        </div>
                              
    
    );
  
  }
}

export default Classify;
